//=====================================================
// 予約日時を決めるボタン
//=====================================================

interface IFProps {
    enable : boolean,
    onClick? : React.MouseEventHandler<HTMLButtonElement>
}

export function BtnReservation(props: IFProps){
 
    return (
        <>
            { props.enable ?
                <button onClick={props.onClick}  className="btn btn-primary btn-reserve">予約日時を決める</button>
                :
                <button className="btn btn-primary btn-reserve is-inactive">Webからの予約不可</button>
            }
        </>
    );

}